import React, { memo } from "react";
import { RouterProvider } from "react-router-dom";
import AppRouter from "./routing/Routing";

const Root = memo(() => {
  return <RouterProvider router={AppRouter} />;
});

export default Root;
